import { AuthGuard } from './../shared/guards/auth.guard';

export const rootRoute = {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    redirectTo: 'novelties'
};
